export default __webpack_public_path__ + "static/media/RC.362b66e9.png";